import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { gql } from 'graphql-request';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router';
import { Button, Card, CardContent } from '@mui/material';

import {
  ViewTitle,
  Loading,
  Error,
  BackButton,
  MOTemplateForm,
} from '../../../components';
import * as actions from '../../../redux/actions';
import graphqlClient from '../../../configs/graphqlClient';
import { app as appConfig } from '../../../configs';

/**
 * @function SettingEditMOTemplate
 * @description Display a collections or a list of SettingEditMOTemplate from database
 */

export default function SettingEditMOTemplate({ title, subtitle }) {
  const dispatch = useDispatch();
  const product = useSelector((state) => state.product);
  const material = useSelector((state) => state.material);
  const processTemplate = useSelector((state) => state.processTemplate);
  const moTemplate = useSelector((state) => state.moTemplate);

  const history = useHistory();
  const params = useParams();
  const {
    control,
    watch,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  const query = gql`
    query FindSettingCreateMOTemplate(
      $materialInput: MaterialInput
      $productInput: ProductInput
      $processTemplateInput: ProcessTemplateInput
      $moTemplateInput: MOTemplateInput
    ) {
      findMaterials(input: $materialInput) {
        total
        rows {
          _id
          type_code
          name
        }
      }
      findProducts(input: $productInput) {
        total
        rows {
          _id
          type_code
          name
        }
      }
      findProcessTemplates(input: $processTemplateInput) {
        total
        rows {
          _id
          name
        }
      }
      findOneMOTemplate(input: $moTemplateInput) {
        _id
        name
        processes {
          index
          process_template {
            _id
            name
          }
          produce_material_instead
          product_as_material {
            _id
            name
            type_code
          }
          product {
            _id
            name
            type_code
          }
          no_product
        }
      }
    }
  `;

  const queryDataFromServer = async () => {
    try {
      const queryResult = await graphqlClient.request(query, {
        materialInput: {
          size: appConfig.maxFetchSize,
          fetchStockLot: false,
          status: '',
        },
        productInput: {
          size: appConfig.maxFetchSize,
          fetchStockLot: false,
          status: '',
        },
        processTemplateInput: {
          size: appConfig.maxFetchSize,
        },
        moTemplateInput: {
          id: params.id,
        },
      });
      const materialData = queryResult?.findMaterials;
      const productData = queryResult?.findProducts;
      const processTemplateData = queryResult?.findProcessTemplates;
      const moTemplatedata = queryResult?.findOneMOTemplate;
      dispatch(actions.materialStateSet(materialData));
      dispatch(actions.productStateSet(productData));
      dispatch(actions.processTemplateStateSet(processTemplateData));
      dispatch(actions.moTemplateStateOneSet(moTemplatedata));
    } catch (error) {
      console.error('Cannot Fetch Element', error);
      // ให้ตัวใดตัวหนึ่ง Error เพื่อที่จะให้หน้าแสดงเป็๋น Error Page
      dispatch(actions.moTemplateError());
    }
  };

  useEffect(() => {
    queryDataFromServer();
    return () => {};
  }, []);

  useEffect(() => {
    if (moTemplate?.processes) {
      setValue('processes', moTemplate?.processes);
      setValue('name', moTemplate?.name);
    }

    return () => {};
  }, [moTemplate]);

  const onSubmitMOTemplate = async (data) => {
    try {
      await dispatch(actions.moTemplatePut(params.id, data));
      alert('สำเร็จ');
      history.goBack();
    } catch (error) {
      alert('แก้ไขสูตรคำสั่งผลิตไม่สำเร็จ');
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (processTemplate.isLoading || moTemplate?.isLoading) {
    return <Loading />;
  }
  if (
    !moTemplate?.isLoading &&
    moTemplate?.isCompleted &&
    !processTemplate.isLoading &&
    processTemplate.isCompleted
  ) {
    return (
      <div>
        {renderTitle()}
        <div>
          <BackButton />
        </div>
        <div className="my-2">
          <Card>
            <CardContent>
              <form onSubmit={handleSubmit(onSubmitMOTemplate)}>
                <MOTemplateForm
                  control={control}
                  errors={errors}
                  material={material}
                  processTemplate={processTemplate}
                  product={product}
                  watch={watch}
                  moTemplate={moTemplate}
                  setValue={setValue}
                />
                <div className="flex justify-end">
                  <Button variant="contained" type="submit">
                    บันทึก
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

SettingEditMOTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

SettingEditMOTemplate.defaultProps = {
  title: '',
  subtitle: '',
};
